import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroCarousel from './components/HeroCarousel';
import PopularSection from './components/PopularSection';
import TopicSection from './components/TopicSection';
import NewsSection from './components/NewsSection';
import { shows } from '@/mocks/shows';
import { newsList } from '@/mocks/news';

export default function Home() {
  const heroItems = shows.filter((s) => s.featured);
  const popularItems = shows.filter((s) => s.hot).concat(shows.filter((s) => !s.hot)).slice(0, 6);
  const familyTopic = shows.filter((s) => s.genres.includes('家庭') || s.genres.includes('伦理')).slice(0, 4);
  const movieTopic = shows.filter((s) => s.type === 'movie').slice(0, 4);
  const latestNews = newsList.slice(0, 5);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroCarousel items={heroItems} />

        <h1 className="sr-only">同学的妈妈影视大全 - 电视剧电影剧情介绍与资讯</h1>

        <PopularSection items={popularItems} />

        <TopicSection
          title="家庭伦理剧推荐"
          description="细腻刻画中国式亲情的温暖与羁绊"
          icon="ri-home-heart-line"
          items={familyTopic}
          moreTo="/category/tv/family"
          tone="primary"
        />

        <TopicSection
          title="年度热门电影合集"
          description="院线口碑佳作，不容错过的观影之选"
          icon="ri-movie-2-line"
          items={movieTopic}
          moreTo="/category/movie/hot"
          tone="accent"
        />

        <NewsSection items={latestNews} />
      </main>
      <Footer />
    </div>
  );
}